@if (displayType() !== 'panel') {
  <mat-form-field
    class="w-full"
    [class.mb-5]="displayType() !== 'filter' && (!required() || !hasError())"
    [class.select-classic]="displayType() === 'select'"
    [class.stroked-select-single]="displayType() === 'filter'"
    [ngClass]="cssClass()"
    appearance="outline"
  >
    @if (displayType() === 'filter') {
      <mat-select-trigger>Building</mat-select-trigger>
    }
    <mat-select
      (blur)="onBlur()"
      (openedChange)="onPanelChange($event)"
      (valueChange)="valueChanged($event)"
      [disabled]="disabled()"
      [value]="value()"
      panelClass="single-select-overlay"
      placeholder="Select location"
    >
      @if (displayType() === 'filter') {
        <mat-option value="">All</mat-option>
      }
      @for (location of locations(); track location.id) {
        <mat-option [value]="location.id">
          {{ location.friendlyName }}
        </mat-option>
      }
    </mat-select>
    <mat-icon
      class="arrow-down"
      fontIcon="keyboard_arrow_down"
      matSuffix
    />
  </mat-form-field>
} @else {
  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title>
        <div class="mobile-single-select-title">
          Building
          @if (selectedLocation()) {
            : {{ selectedLocation()!.friendlyName }}
          }
        </div>
        @if (selectedLocation()) {
          <button
            class="mobile-filter-clear-btn"
            (click)="changed.emit(null)"
          >
            Clear
          </button>
        }
      </mat-panel-title>
    </mat-expansion-panel-header>
    <ul class="mobile-single-filter-select">
      @for (building of locations(); track building.id) {
        <li
          (click)="changed.emit(building.id)"
          [class.checked]="building.id === selectedLocation()?.id"
        >
          <span>{{ building.friendlyName }}</span>
          <i class="icon-check text-ui-green-light text-3xl"></i>
        </li>
      }
    </ul>
  </mat-expansion-panel>
}
